import React from "react";
import HelpSidebar from "./HelpSidebar";
import { Outlet } from "react-router-dom";
import "./HelpLayout.css";

const HelpLayout = () => {
  return (
    <section className="helpLayout container-xl">
      <div className="row">
        <div className="col-md-3">
          <HelpSidebar />
        </div>
        <div className="col-md-9">
          <div className="helpContent p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpLayout;
